import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const HomeSlider = () => {
  useEffect(() => {
    const carousel = new window.bootstrap.Carousel(
      document.querySelector("#carouselExampleCaptions"),
      {
        interval: 3000,
        ride: "carousel",
      },
    );
    carousel.cycle();
  }, []);

  return (
    <div className="slider-sec">
      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide12.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide17.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide18.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide19.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide20.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          {/* <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide13.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div> */}
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide14.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide15.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide6.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>

          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide5.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide4.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide3.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide2.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide1.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          {/* <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide7.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div> */}
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide8.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide9.jpg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide10.png"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
          <div className="carousel-item" data-bs-interval="3000">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFSAP/public/Images/slide11.jpeg"
              className="d-block w-100"
              alt="St francis school, Amritsar"
            />
          </div>
        </div>

        {/* LEFT ARROW */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>

        {/* RIGHT ARROW */}
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default HomeSlider;
